module.exports = __webpack_public_path__ + "img/9788963711768.567469cf.jpg";